( function( $ ) {
if (!window.quizKitScriptLoaded) {
  window.quizKitScriptLoaded = true;
  const script = document.createElement('script');
  script.defer = true;
  script.setAttribute('src', 'https://d38jc50suw8dg3.cloudfront.net/current/static/bundle.min.js');
  document.head.appendChild(script);
  const appStyles = document.createElement('link');
  appStyles.type = 'text/css';
  appStyles.rel = 'stylesheet';
  appStyles.href = 'https://d38jc50suw8dg3.cloudfront.net/undefined/static/main.min.css';
  appStyles.media = 'print';
  appStyles.onload = function() {
    this.media='all'
  };
  document.head.appendChild(appStyles);
}



document.addEventListener('quizKitQuestionLoaded', function (e) {
    if (!e?.detail?.id) return;
    const questionId = e.detail.id;
    const selector = `#quiz-kit-question-grid-${questionId}`;

    const applyStylesUpToH1 = (button) => {
        let parent = button.parentElement;

        while (parent && parent.tagName !== 'H1') {
            parent.style.display = 'flex';
            parent.style.flexDirection = 'column';
            parent.style.justifyContent = 'start';
            parent.style.setProperty('width', '100%', 'important');
            parent = parent.parentElement;
        }
    };

    const enhanceButton = (button) => {
        // add class to FIRST parent div
        const parentDiv = button.parentElement;
        if (parentDiv && parentDiv.tagName === 'DIV') {
            parentDiv.classList.add('quiz-button');
        }

        // target: button > div > first span
        const targetSpan = button.querySelector('div > span:first-of-type');
        if (!targetSpan) return;

        // prevent duplicate chevrons
        if (!targetSpan.querySelector('.fa-chevron-right')) {
            const icon = document.createElement('i');
            icon.className = 'fas fa-chevron-right';
            targetSpan.appendChild(icon);
        }
    };

    const assignIds = (container) => {
        const buttons = container.querySelectorAll('button');
        for (let i = 0; i < buttons.length; i++) {
            const btn = buttons[i];
            btn.id = `button_${questionId}_${i}`;
            applyStylesUpToH1(btn);
            enhanceButton(btn);
        }
    };

    const observeContainer = (container) => {
        const observer = new MutationObserver(() => {
            assignIds(container);
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    };

    // Try immediately
    let container = document.querySelector(selector);
    if (container) {
        assignIds(container);
        observeContainer(container);
        return;
    }

    // Wait for container insertion
    const bodyObserver = new MutationObserver(() => {
        container = document.querySelector(selector);
        if (!container) return;

        bodyObserver.disconnect();
        assignIds(container);
        observeContainer(container);
    });

    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}, false);

const TOTAL_STEPS = 9;
const STEP_SIZE = 100 / TOTAL_STEPS;
const progressBar = document.getElementById('progress-bar');
let currentStep = 1;

// --- Utility Function (Must be defined globally) ---
const updateProgressBar = () => {
    currentStep = Math.min(Math.max(1, currentStep), TOTAL_STEPS);
    const newWidth = currentStep * STEP_SIZE;
    progressBar.style.width = newWidth + '%';
};

// --- The Next Step Function (Must be defined globally) ---
const nextStep = () => {
    if (currentStep < TOTAL_STEPS) {
        currentStep++;
        updateProgressBar();
    } else {
        console.log("Survey complete!");
    }
};

// Initial state
updateProgressBar();

document.addEventListener('click', function (e) {
    // 1. Identify the button that was clicked
    const button = e.target.closest('button');

    // Exit if not a button or no ID
    if (!button || !button.id) return;

    const buttonId = button.id; 
    let targetModalId = ''; 

    // *** IMPORTANT FILTERING STEP ***
    // Check if the clicked button is one of the control buttons we want to ignore.
    if (buttonId === 'back' || buttonId === 'quiz-kit-question-prev-button') {
        // Exit the listener immediately. The dedicated 'goBack' listener 
        // will handle these IDs separately.
        console.log(`Ignoring control button click: ${buttonId}`);
        return;
    }
    // **********************************

    // --- Switch Statement: Assigning a specific modal ID based on the button ID ---
    switch (buttonId) {

        // Question 1 - Anything but excellent (Responses 1, 2, 3)
        case 'button_185192_1': 
        case 'button_185192_2':
        case 'button_185192_3':
            targetModalId = 'q1';
            break;

        // Question 2 - Any response (Responses 0, 1, 2, 3, 4)
        case 'button_185622_0':
        case 'button_185622_1':
        case 'button_185622_2':
        case 'button_185622_3':
        case 'button_185622_4':
            targetModalId = 'q2';
            break;

        // Question 4 - Issue (Responses 0, 3, 4)
        case 'button_185678_0':
        case 'button_185678_3':
        case 'button_185678_4':
            targetModalId = 'q4-issue';
            break;

        // Question 4 - Health (Responses 1, 2)
        case 'button_185678_1':
        case 'button_185678_2':
            targetModalId = 'q4-health';
            break;

        // Question 5 - Yes, currently (Responses 0, 1)
        case 'button_185679_0':
        case 'button_185679_1':
            targetModalId = 'q5-yes';
            break;

        // Question 5 - Not, not (Response 2)
        case 'button_185679_2':
            targetModalId = 'q5-no';
            break;

        // Question 6 - Not sure results (Response 0)
        case 'button_185680_0':
            targetModalId = 'q6-results';
            break;

        // Question 6 - Cost worry (Response 1)
        case 'button_185680_1':
            targetModalId = 'q6-cost';
            break;

        // Question 6 - Not eat it (Response 2)
        case 'button_185680_2':
            targetModalId = 'q6-eat';
            break;

        // Question 7 - Average (Response 1)
        case 'button_185681_1':
            targetModalId = 'q7-avg';
            break;

        // Question 7 - Active (Responses 0, 2)
        case 'button_185681_0':
        case 'button_185681_2':
            targetModalId = 'q7-active';
            break;

        // Question 7 - Not Active (Response 3)
        case 'button_185681_3':
            targetModalId = 'q7-not-active';
            break;

        // Default Case: Progress advances, but no modal is targeted.
        default:
            console.warn(`Button ID "${buttonId}" did not match any specific modal case. Progress will still advance.`);
            break;
    }

    // *** PROGRESS BAR ACTION ***
    // 1. Advance the progress bar for every valid survey button click.
    nextStep(); 
    // *****************************************

    // 2. Safely check if a modal needs to be displayed.
    if (targetModalId === '') {
        console.log(`No specific modal to show for button "${buttonId}".`);
        return; 
    }

    // Find the modal element using the determined targetModalId
    const modal = document.getElementById(targetModalId);

    // Exit if the required modal doesn't exist in the DOM
    if (!modal) {
        console.error(`Modal with ID "${targetModalId}" not found for button "${buttonId}".`);
        return;
    }

    // 3. Show the determined modal
    modal.style.display = 'block';

    console.log(`Successfully mapped button "${buttonId}" to modal "${targetModalId}"`);
});


// Close modal
document.addEventListener('click', function (e) {
    if (
        e.target.classList.contains('overlay') ||
        e.target.classList.contains('close')
    ) {
        const modal = e.target.closest('.quick-modal');
        if (modal) modal.style.display = 'none';
    }
});


const goBack = () => {
     console.log('clicked back');
    // 1. Progress Bar Logic
    if (currentStep > 1) {
        currentStep--;
        updateProgressBar();
    } else {
        console.log("Already at the first step. Progress not changed.");
    }

    // 2. Existing Quiz Kit Button Logic
    const tryClick = () => {
        const btn = document.querySelector('#quiz-kit-question-prev-button');
        if (btn) {
            btn.click();
            return true;
        }
        return false;
    };

    if (tryClick()) return;

    // Use MutationObserver if the button might load dynamically
    const observer = new MutationObserver(() => {
        if (tryClick()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
};



document.getElementById('back').addEventListener('click', goBack);

updateProgressBar();

$(document).ready(function(){

});
} )( jQuery );